import { Group, Stack } from '@mantine/core';
import { IconButton } from '@repo/foundations';
import {
	useLineageFlowContext,
	useLineageFlowUIContext,
} from '../../context/LineageFlowProvider/LineageFlowContext';
import ActionBarSearch from './ActionBarSearch';

import { observer } from 'mobx-react-lite';
import type { ActionBarProps } from './ActionBar.types';
import ActionBarMenu from './ActionBarMenu';

function ActionBar({ children }: ActionBarProps) {
	const { onExportToPNG, onReinitialize, onExpandAllNodes } =
		useLineageFlowContext();

	const { isFullscreen, setIsFullscreen, flowActions } =
		useLineageFlowUIContext();

	return (
		<Stack spacing="sm">
			<Group position="apart" noWrap>
				<ActionBarSearch />
				<Group spacing="xs">
					<IconButton
						variant="tertiary"
						tooltip="Reinitialize lineage"
						iconName="refresh"
						onClick={onReinitialize}
					/>
					<IconButton
						variant="tertiary"
						tooltip={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
						iconName={
							isFullscreen ? 'arrowsDiagonalMinimize' : 'arrowsDiagonal'
						}
						onClick={() => setIsFullscreen(!isFullscreen)}
						data-testid="lineage-controls-fullscreen-70b077616"
					/>
					<ActionBarMenu
						onExportToPNG={onExportToPNG}
						onExpandAllNodes={onExpandAllNodes}
						flowActions={flowActions}
					/>
				</Group>
			</Group>
			{children}
		</Stack>
	);
}

const ObservedActionBar = observer(ActionBar);

export default ObservedActionBar;
